import { Dayjs } from "dayjs";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
dayjs.extend(relativeTime);
dayjs.extend(duration);
export function formatDate(date?: string | Dayjs) {
  if (date === null || date === undefined || date === "") {
    return "-";
  }
  return dayjs(date).format("DD/MM/YYYY");
}

export function formatDateTime(
  date: string | Dayjs,
  options?: { seconds: boolean },
) {
  if (date === null || date === undefined || date === "") {
    return "-";
  }
  return dayjs(date).format(
    "DD/MM/YYYY HH:mm" + (options?.seconds ? ":ss" : ""),
  );
}

export const datePickerFormat = "DD/MM/YYYY";

export function formatDurationMilliseconds(
  durationMs: number,
  t: (str: string) => string,
  unitDepth: number = 1,
) {
  if (durationMs === null || durationMs === undefined) {
    return "-";
  }
  return formatDuration(dayjs.duration(durationMs).toISOString(), t, unitDepth);
}

export function formatDurationBetweenDates(
  start: string,
  end: string,
  t: (str: string) => string,
  unitDepth: number = 1,
) {
  if (!start || !end) {
    return "-";
  }
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  const duration = dayjs.duration(endDate.diff(startDate));
  return formatDuration(duration.toISOString(), t, unitDepth);
}
// Formats ISO 8601 duration strings with configurable unit depth
// unitDepth controls how many units to display (e.g., unitDepth=1: "1 day", unitDepth=2: "1 day, 4 hours")
export function formatDuration(
  duration: string,
  t: (str: string) => string,
  unitDepth: number = 1,
) {
  const nr = "\\d+(?:[\\.,]\\d+)?";
  const dateRegex = `(${nr}Y)?(${nr}M)?(${nr}W)?(${nr}D)?`;
  const timeRegex = `T(${nr}H)?(${nr}M)?(${nr}S)?`;
  const durationRegex = new RegExp(`P${dateRegex}(?:${timeRegex})?`);
  const parsePart = (val: string | null) =>
    val ? Math.floor(parseFloat(val)) : 0;

  if (!duration) {
    return "-";
  }

  if (duration === "PT0S") {
    return `0`;
  }

  try {
    const match = duration.match(durationRegex);
    if (!match) {
      throw new Error("Invalid duration format");
    }

    const years = parsePart(match[1]);
    const months = parsePart(match[2]);
    const weeks = parsePart(match[3]);
    const days = parsePart(match[4]);
    const hours = parsePart(match[5]);
    const minutes = parsePart(match[6]);
    const seconds = parsePart(match[7]);

    const units = [
      { value: years, unit: "years" },
      { value: months, unit: "months" },
      { value: weeks, unit: "weeks" },
      { value: days, unit: "days" },
      { value: hours, unit: "hours" },
      { value: minutes, unit: "minutes" },
      { value: seconds, unit: "seconds" },
    ];

    const nonZeroUnits = units.filter((u) => u.value > 0);

    if (nonZeroUnits.length === 0) {
      return `0`;
    }

    const displayUnits = nonZeroUnits.slice(0, unitDepth);

    return displayUnits
      .map((u) => `${u.value} ${t(u.unit, u.value)}`)
      .join(", ");
  } catch (e) {
    console.error("Error parsing duration: ", duration);
    return "-";
  }
}

export function formatPassedDuration(date: string): string {
  if (date) {
    return dayjs(date).fromNow();
  }
  return "-";
}
